import { render, staticRenderFns } from "./SubscriptionModal.vue?vue&type=template&id=5207990f&scoped=true"
import script from "./SubscriptionModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionModal.vue?vue&type=style&index=0&id=5207990f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207990f",
  null
  
)

export default component.exports